import React from 'react';
import PropTypes from 'prop-types';

export default function Search(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.width} height={props.width} stroke={props.color} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
  );
}

Search.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

Search.defaultProps = {
  color: '#888',
  width: 24,
};